// import visible from '../util/visible';
import $ from 'jquery';
import 'tilt.js';
// import anime from 'animejs';
import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment'




export default {
  init() {



    new Vue({
      el: '#blogs',

      data: function() {
        return {
          blogs: [],
          currentCategory: 'all',
        }
      },


      methods: {
        changeCategory(c) {
          let self = this;
          $('#blog-overview').fadeOut(300, function(){
            self.currentCategory = c;
            window.history.replaceState({}, '', '#'+self.currentCategory);

            $('#blog-overview').fadeIn(300);

            setTimeout(function() {
              $('.js-tilt').tilt({
                perspective: 2000,
              })

            }, 500)
          })
        },

        getDate(date) {

          return  moment(date).format('Do MMMM YYYY')
        },

      },
      mounted() {


        let self = this;

        if(window.location.hash) {
          let hash = window.location.hash.substring(1);
          this.changeCategory(hash)

        } else {
          // No hash found
        }

        $.ajax({
          url: '/wp-json/wp/v2/posts?_embed=1&per_page=99',
          context: document.body,
        }).done(function(response) {
          self.blogs = response;
        });

      },

      computed: {
        visibleBlogs() {

          if(this.currentCategory==='all'){
            return this.blogs
          }

          let self = this;
          return _.filter(this.blogs, function (blog) {
            for (let i = 0; i < blog._embedded['wp:term'][0].length; i++) {
              if (blog._embedded['wp:term'][0][i].name === self.currentCategory) {
                return true
              }
            }
          });


        },
      },

    })

  },
};


$(document).ready(() => {

  setTimeout(function() {
    $('.js-tilt').tilt({
      perspective: 2000,
    })

  }, 2000)
});

